type LenisLike = {
    on?: (event: string, cb: (e: { scroll: number }) => void) => void;
    scroll?: number;
    scrollTo?: (target: number, opts?: { duration?: number }) => void;
};

const SHOW_THRESHOLD = 420;
const HIDE_THRESHOLD = 280;

/**
 * 우하단 quick menu는 최초 로드부터 유지하고, TOP 버튼만 스크롤 위치로 표시한다.
 * show/hide hysteresis 로 임계값 근처 TOP 버튼 깜빡임을 줄인다.
 */
export class FloatingCtaController {
    static init(): void {
        const el = document.querySelector<HTMLElement>("[data-quick-menu]");
        if (!el) return;

        const lenis = (window as unknown as { lenis?: LenisLike }).lenis;
        const topButtons = Array.from(el.querySelectorAll<HTMLButtonElement>("[data-quick-menu-top]"));

        let topVisible = false;
        let frame = 0;
        let lastOffset = 0;

        const apply = (offset: number): void => {
            const shouldShow = topVisible ? offset > HIDE_THRESHOLD : offset > SHOW_THRESHOLD;
            if (shouldShow === topVisible) return;
            topVisible = shouldShow;
            topButtons.forEach((btn) => {
                btn.classList.toggle("is-visible", shouldShow);
                btn.toggleAttribute("aria-hidden", !shouldShow);
                btn.tabIndex = shouldShow ? 0 : -1;
            });
        };

        const scheduleApply = (offset: number): void => {
            lastOffset = offset;
            if (frame !== 0) return;
            frame = window.requestAnimationFrame(() => {
                frame = 0;
                apply(lastOffset);
            });
        };

        topButtons.forEach((btn) => {
            btn.addEventListener("click", (event) => {
                event.preventDefault();
                if (lenis?.scrollTo) {
                    lenis.scrollTo(0, { duration: 1.2 });
                    return;
                }
                window.scrollTo({ top: 0, behavior: "smooth" });
            });
        });

        if (lenis?.on) {
            lenis.on("scroll", (e) => scheduleApply(e.scroll ?? window.scrollY));
            apply(lenis.scroll ?? window.scrollY);
        } else {
            const onScroll = (): void => scheduleApply(window.scrollY);
            window.addEventListener("scroll", onScroll, { passive: true });
            onScroll();
        }
    }
}
